@if (videoFile; as file) {
<div class="media-viewer" [class.media-viewer--audio]="file.type === 'AUDIO'">
  @if (showHeader) {
    <div class="media-viewer__header">
      <div class="media-viewer__title">
        <mat-icon aria-hidden="true">{{ file.type === 'AUDIO' ? 'graphic_eq' : 'movie' }}</mat-icon>
        <span>{{ file.name }}{{ file.extension }}</span>
      </div>

      <button
        mat-icon-button
        type="button"
        matTooltip="Sluiten"
        i18n-matTooltip
        aria-label="Sluiten"
        i18n-aria-label
        (click)="closeDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <div class="media-viewer__content">
    @if (file.type === 'VIDEO') {
      <video #videoPlayer class="media-viewer__video" controls>
        Your browser does not support the video tag.
      </video>
    }

    @if (file.type === 'AUDIO') {
      <div class="media-viewer__audio-panel">
        <div class="media-viewer__audio-icon" aria-hidden="true">
          <mat-icon>graphic_eq</mat-icon>
        </div>

        <audio #audioPlayer class="media-viewer__audio" controls>
          <source [src]="file | audioCdnLink" type="audio/mpeg">
          Your browser does not support the audio tag.
        </audio>
      </div>
    }
  </div>
</div>
}
